import * as React from 'react';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { find, flow } from 'lodash';
import { connect } from 'react-redux';
import { IQuoteState } from '../../../../services/quote/models';
import { IStore } from '../../../../redux/IStore';
import FieldFormControl from '../../../../components/FieldFormControl';
import { isRequired, isNotFalse } from '../../../../util/validators';
import { Col, Row, OverlayTrigger, Popover } from 'react-bootstrap';
import FaClose from 'react-icons/fa/close';
import * as Commonmark from 'react-commonmark';
import FaInfo from 'react-icons/fa/info';
import FaInfoCircle from 'react-icons/fa/info-circle';
import { IChannel } from '../../../../data/api/models';

interface IDeclarationConsentProps {
  quote: IQuoteState;
  dispatch: any;
  productTerms: any;
  productDefinitions: any;
  channel: IChannel;
  isMobileView: boolean;
}

class DeclarationConsent extends React.Component<IDeclarationConsentProps> {
  private onClose = () => {
    document.body.click();
  }

  private renderDefinition = (name: string, icon?: string) => {
    const { productDefinitions, isMobileView } = this.props;
    const definition = productDefinitions[name];

    if (!definition) {
      return null;
    }

    const popover = (
        <Popover
            id={`popover-${name}`}
            onClick={this.onClose}
        >
          <div className="close-container">
            <div className="close-tooltip">
              <FaClose/>
            </div>
            <Commonmark
                source={definition}
                linkTarget="_blank"
            />
          </div>
        </Popover>
    );

    return (
        <OverlayTrigger
            trigger="click"
            rootClose={true}
            overlay={popover}
            placement={isMobileView ? 'bottom' : 'right'}
            positionLeft={200}
        >
          {icon === 'FaInfo' ? <FaInfo className="info-btn-helper"/> : <FaInfoCircle className="info-btn"/>}
        </OverlayTrigger>
    );
  }

  private transformLinks = (url) => () => {
    const { channel } = this.props;

    if (url === 'policy_wording' || url === 'Insurance Policy') {
      const pwDocument = find(channel.productDocuments, (document) => {
        return document.shortName === 'Evidence of Cover';
      });

      if (pwDocument) {
        return pwDocument.filePath;
      }
    }

    return url;
  }

  public render() {
    const { productTerms } = this.props;

    if (Object.keys(productTerms).length === 0) {
      return null;
    }

    const productTermsValues = Object.values(productTerms);
    const sortedProductTerms = productTermsValues.sort((a, b) => a.questionOrder - b.questionOrder);

    const termsOfProduct = sortedProductTerms.map((productTerm) => {
      if (productTerm.key !== '') {
        const hasDefinition = productTerm.hasDefinition;
        const isQuestion = productTerm.question;
        const contentCol = isQuestion ? 10 : 12;

        return (
            <div className="product-term-container" key={productTerm.key}>
              <Row>
                <Col sm={contentCol}>
                  <div className="declaration-container">
                    {this.props.channel.key === 'css-b2c' ? (
                        <Commonmark
                            className="declaration-content"
                            linkTarget="_blank"
                            source={productTerm.content}
                        />
                    ) : (
                        <Commonmark
                            className="declaration-content"
                            source={productTerm.content}
                            linkTarget="_blank"
                            transformLinkUri={this.transformLinks('policy_wording')}
                        />
                    )}

                    {hasDefinition && (
                        <div className="declaration-definition">{this.renderDefinition(productTerm.key)}</div>
                    )}
                  </div>
                </Col>
                {isQuestion && (
                    <Col sm={2}>
                      <div className="declaration-question">
                        <Field
                            name={productTerm.key}
                            type="checkbox"
                            component={FieldFormControl}
                            validate={[
                              isRequired,
                              isNotFalse,
                            ]}
                        >
                          <div />
                        </Field>
                      </div>
                    </Col>
                )}
              </Row>
            </div>
        );
      }

      return null;
    });

    return (
        <div className="declaration-product-terms-container">
          <p>I declare (please tick to confirm):
          </p>
          <div>
            {termsOfProduct}
          </div>
        </div>
    );
  }
}

let selector;
export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
      (state: IStore) => {
        return {
          quote: state.quote,
        };
      },
  ),
])(DeclarationConsent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/DeclarationConsent/index.tsx